'use client';

import { useEffect } from 'react';
import { ErrorCard } from '@repo/ui/error-card';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Surface the error so it is not silently swallowed by the boundary.
    console.error(error);
  }, [error]);

  return (
    <main className="flex h-full w-full items-center justify-center">
      <ErrorCard
        error={{
          message: error.message,
          details: error.digest,
        }}
        retry={reset}
      />
    </main>
  );
}
